import React from "react";
import "./button.scss";
import { findRel } from "../../../shared/utils/stringUtilities";

const Button = (props: ButtonInterface) => {
    const {
        id,
        type,
        classname,
        text,
        onClickAction,
        isDisabled,
        href,
        icon,
        gtmMark,
        strictCss,
        target,
        self,
        children,
        data,
    } = props;
    const valStrictCss = strictCss ? "" : "a-button ";

    const isHttp = (url?: string) => {
        return url?.startsWith("http");
    };
    const valTarget = isHttp(href) ? "_blank" : target || "_self";

    // Si text no está definido, retorna un fragmento vacío
    if (!text) return <></>;

    switch (type) {
        case 'button':
            return <button
                id={id}
                className={`${valStrictCss} ${classname} ${gtmMark}`}
                disabled={isDisabled}
                onClick={onClickAction}
                data={data}
            >
                {text}
                {children}
            </button>;
        case 'link':
            return <a
                id={id}
                href={href}
                target={self ? "_self" : valTarget}
                rel={findRel(href)}
                onClick={onClickAction}
                className={`${valStrictCss} ${classname} ${gtmMark}`}
                data={data}
            >
                {icon && <span className={`${icon}`} />}
                {text}
                {children}
            </a>;
        default:
            return <input
                className={`${valStrictCss} ${classname} ${gtmMark}`}
                type="submit"
                value={text}
                disabled={isDisabled}
                data={data}
            />;
    }
};

interface ButtonInterface {
    id?: string;
    type: "button" | "input" | "link";
    classname: string;
    text: React.ReactNode | string | null | undefined;
    onClickAction?: () => any;
    isDisabled: boolean | undefined;
    icon?: string;
    href?: string;
    gtmMark?: string;
    strictCss?: boolean;
    self?: boolean;
    target?: string;
    children?: any;
    data?: any;
}

export default Button;
